import axios from 'axios';

//export let baseURL = 'https://localhost:3050';
export let baseURL = 'https://test.admia.sde.gob.hn:3050';

const api = axios.create({
    baseURL: baseURL,
    withCredentials: true
})

export default api;